import { create } from 'zustand';

interface StoreState {
  headerData: undefined | any;
  setHeaderData: any;
  footerData: undefined | any;
  setFooterData: any;
  projectFooterData: undefined | any;
  setProjectFooterData: any;
  globalData: undefined | any;
  notificationData: undefined | any;
  setNotifications: any;
  setGlobalData: any;
  lenis: undefined | any;
  setLenis: any;
  mainHeight: undefined | any;
  setMainHeight: any;
  overflow: undefined | any;
  setOverflow: any;
  triggerTransition: undefined | any;
  setTriggerTransition: any;
  introOut: undefined | any;
  setIntroOut: any;
  headerLight: undefined | any;
  setHeaderLight: any;
  menuOpen: undefined | any;
  setMenuOpen: any;
  notificationHeight: undefined | any;
  setNotificationHeight: any;
}

export const useStore = create<StoreState>((set) => ({
  headerData: undefined,
  setHeaderData: (headerData) => set({ headerData }),
  footerData: undefined,
  setFooterData: (footerData) => set({ footerData }),
  projectFooterData: undefined,
  setProjectFooterData: (projectFooterData) => set({ projectFooterData }),
  globalData: undefined,
  setGlobalData: (globalData) => set({ globalData }),
  notificationData: undefined,
  setNotifications: (notificationData) => set({ notificationData }),
  lenis: undefined,
  setLenis: (lenis) => set({ lenis }),
  mainHeight: undefined,
  setMainHeight: (mainHeight) => set({ mainHeight }),
  overflow: true,
  setOverflow: (overflow) => set({ overflow }),
  triggerTransition: '',
  setTriggerTransition: (triggerTransition) => set({ triggerTransition }),
  introOut: false,
  setIntroOut: (introOut) => set({ introOut }),
  headerLight: false,
  setHeaderLight: (headerLight) => set({ headerLight }),
  menuOpen: false,
  setMenuOpen: (menuOpen) => set({ menuOpen }),
  notificationHeight: 0,
  setNotificationHeight: (notificationHeight) => set({ notificationHeight }),
}));
